import { axiosClient } from "@/lib/axiosClient";
import type { ConfigApp, ConfigAppPayload } from "@/types/configApp";
const CONFIG_ID = 1;

export const configAppService = {
    // Get Data
    getConfig: async (): Promise<ConfigApp> => {
        const response = await axiosClient.get(`${'pengaturan/app'}/${CONFIG_ID}`);
        return response.data;
    },
    // Update Data
    updateConfig: async (data: ConfigAppPayload): Promise<ConfigApp> => {
        const response = await axiosClient.put(`${'pengaturan/app'}/${CONFIG_ID}`, data);
        return response.data;
    },
};